import React from "react";
import { Form } from "antd";
import {useSelector} from "react-redux";
import { useDispatch } from "react-redux";
import {ShowLoading,HideLoading} from "../../redux/rootSlice";
import axios from "axios";
import {message} from 'antd';

function AdminIntro() {
  const dispatch = useDispatch();
  const {portFolioData} = useSelector((state)=>state.root);
  const onFinish = async (values) => {
    try{
      dispatch(ShowLoading());
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/portfolio/update-intro`,{
        ...values,
        _id:portFolioData.intro._id,
      });
      dispatch(HideLoading());
      if(response.data.success){
        message.success(response.data.message);
      }else{
        message.error(response.data.message);
      }
    }catch(error){
      dispatch(HideLoading());
      message.error(error.message);
    }
  };

  return (
    <div>
      <Form onFinish={onFinish} layout="vertical" initialValues={portFolioData.intro}>
        <Form.Item name="welcomeText" label="welcomeText">
          <input placeholder="Intro" />
        </Form.Item>
        <Form.Item name="firstName" label="First name">
          <input placeholder="First Name" />
        </Form.Item>
        <Form.Item name="lastName" label="Last Name">
          <input placeholder="Last Name" />
        </Form.Item>
        <Form.Item name="caption" label="Caption">
          <input placeholder="Caption" />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <textarea placeholder="Description" />
        </Form.Item>
        <div className="flex justify-end w-full">
          <button className="px-10 py-2 bg-primary text-white" type="submit">Save</button>
        </div>
      </Form>
    </div>
  );
}

export default AdminIntro;
